<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<mat-form-field class="full-width">
	<mat-label>{{ customField.view.label }}</mat-label>
	<input
		matInput
		automationId="customFieldLinkInput"
		class="custom-field-list-input"
		(focus)="internalFocused()"
		(blur)="internalBlurred()"
		[formControl]="internalField"
	/>
	<mat-error *ngIf="internalField.hasError('invalidUrl')">{{
		internalField.getError('invalidUrl')
	}}</mat-error>
</mat-form-field>
<button
	mat-icon-button
	color="primary"
	automationId="openInNewWindow"
	(click)="openLinkInNewTab()"
	[disabled]="disableOpenLinkButton$ | async"
>
	<mat-icon>open_in_new</mat-icon>
</button>
